/**
 * en-GB messages added by Phase 1 task W1 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w1EnGB = {
    // Sites list
    'sitesUi.title': 'Sites',
    'sitesUi.description': 'Site set-up, kiosk look, privacy and devices.',
    'sitesUi.new': 'New site',
    'sitesUi.filter.active': 'Active',
    'sitesUi.filter.archived': 'Archived',
    'sitesUi.filter.all': 'All sites',
    'sitesUi.col.name': 'Name',
    'sitesUi.col.town': 'Town',
    'sitesUi.col.timeZone': 'Time zone',
    'sitesUi.empty': 'No sites match. Add your first site to start signing people in.',
    'sitesUi.status.active': 'Active',
    'sitesUi.status.archived': 'Archived',
    'sitesUi.create.title': 'New site',
    'sitesUi.create.submit': 'Create site',
    'sitesUi.loadFailed': 'This site could not be loaded.',
    // Site details
    'sitesUi.back': 'All sites',
    'sitesUi.tabs': 'Site sections',
    'sitesUi.tab.details': 'Details',
    'sitesUi.tab.groups': 'Groups',
    'sitesUi.tab.look': 'Kiosk look',
    'sitesUi.tab.privacy': 'Privacy',
    'sitesUi.tab.features': 'Features',
    'sitesUi.tab.devices': 'Devices',
    'sitesUi.tab.settings': 'Settings',
    'sitesUi.field.name': 'Site name',
    'sitesUi.field.line1': 'Address line 1',
    'sitesUi.field.line2': 'Address line 2',
    'sitesUi.field.town': 'Town or city',
    'sitesUi.field.county': 'County',
    'sitesUi.field.postcode': 'Postcode',
    'sitesUi.field.timeZone': 'Time zone',
    'sitesUi.field.timeZoneHint': 'Times at this site are shown in this zone.',
    'sitesUi.field.language': 'Language',
    'sitesUi.field.replyToName': 'Reply-to name',
    'sitesUi.field.replyToEmail': 'Reply-to email',
    'sitesUi.field.replyToHint': 'Used on emails sent for this site. Leave empty to use your organisation default.',
    'sitesUi.language.en-GB': 'English (UK)',
    'sitesUi.archive': 'Archive site',
    'sitesUi.archive.confirm': 'Archive this site',
    'sitesUi.archive.hint': 'Archiving hides the site from the kiosk and pickers. Visit history is kept.',
    'sitesUi.restore': 'Restore site',
    'sitesUi.archivedNotice': 'This site is archived. Restore it to change its settings.',
    'sitesUi.links.fields': 'Sign-in questions',
    'sitesUi.links.notices': 'Notices',
    // Site groups tab
    'sitesUi.groups.title': 'Groups at this site',
    'sitesUi.groups.all': 'Show every group',
    'sitesUi.groups.selected': 'Show only the groups I choose',
    'sitesUi.groups.warning': 'People who are signed in to a group you untick will be signed out.',
    'sitesUi.groups.none': 'There are no groups yet.',
    'sitesUi.groups.list': 'Groups shown at this site',
    // Kiosk look
    'sitesUi.look.title': 'Welcome screen',
    'sitesUi.look.welcomeImage': 'Welcome image',
    'sitesUi.look.welcomeImageHint': 'JPEG or PNG up to 2 MB. It is cropped to 2048 by 1536 pixels from the centre.',
    'sitesUi.look.logo': 'Logo',
    'sitesUi.look.logoHint': 'JPEG, PNG or SVG up to 1 MB. Leave empty to use your organisation logo.',
    'sitesUi.look.upload': 'Upload',
    'sitesUi.look.removeImage': 'Remove welcome image',
    'sitesUi.look.removeLogo': 'Remove logo',
    'sitesUi.look.cropPreview': 'Crop preview',
    'sitesUi.look.backgroundColour': 'Background colour',
    'sitesUi.look.textColour': 'Text colour',
    'sitesUi.look.welcomeText': 'Welcome text',
    'sitesUi.look.welcomeTextHint': 'Leave empty for the standard wording.',
    'sitesUi.look.showClock': 'Show the clock',
    'sitesUi.look.defaultWelcome': 'Tap the screen to sign in or out',
    'sitesUi.look.preview': 'Kiosk preview',
    'sitesUi.look.previewLabel': 'What the kiosk welcome screen looks like',
    // Privacy and features
    'sitesUi.privacy.title': 'Privacy',
    'sitesUi.privacy.autocomplete': 'Suggest names of returning visitors as they type',
    'sitesUi.privacy.exactMatch': 'Only show pre-registered names on an exact match',
    'sitesUi.privacy.hideSignOutList': 'Hide visitors’ names on the sign-out list',
    'sitesUi.privacy.requireFullName': 'Ask visitors for at least two words in their name',
    'sitesUi.privacy.hideProductLogo': 'Hide the CloudSign logo on the thank-you screen',
    'sitesUi.features.title': 'Features',
    'sitesUi.features.qr': 'Scan badges and QR codes with the kiosk camera',
    'sitesUi.features.photos': 'Take visitor photos at this kiosk',
    'sitesUi.features.photosHint': 'Each group also has its own photo option, which only applies when this is on.',
    // Devices and settings tabs
    'sitesUi.devices.title': 'Kiosks and printers',
    'sitesUi.devices.description': 'See and manage the devices set up at this site.',
    'sitesUi.devices.open': 'Open devices for this site',
    'sitesUi.settings.title': 'Other settings',
    // Groups list
    'groupsUi.title': 'Groups',
    'groupsUi.description': 'Choose who can sign in, and the order groups appear on the kiosk.',
    'groupsUi.new': 'New group',
    'groupsUi.list': 'Groups, in kiosk order',
    'groupsUi.empty': 'No groups yet. Add a group so people have somewhere to sign in.',
    'groupsUi.kind.standard': 'Standard',
    'groupsUi.kind.repeat': 'Repeat',
    'groupsUi.members': '{count} members',
    'groupsUi.pin': 'PIN set',
    'groupsUi.archivedBadge': 'Archived',
    'groupsUi.orderHint': 'Drag a group, or use the arrows, to change the order on the kiosk.',
    'groupsUi.orderDisabled': 'Show active groups with no search to change the order.',
    'groupsUi.orderSaved': 'Order saved.',
    'groupsUi.create.title': 'New group',
    'groupsUi.create.name': 'Group name',
    'groupsUi.create.kind': 'Type of group',
    'groupsUi.create.standard': 'Standard: one-off visitors such as guests and contractors. They type their details each time.',
    'groupsUi.create.repeat': 'Repeat: a list of known people such as staff or members. They are picked from the list.',
    'groupsUi.create.submit': 'Create group',
    'groupsUi.loadFailed': 'This group could not be loaded.',
    // Group details
    'groupsUi.back': 'All groups',
    'groupsUi.tabs': 'Group sections',
    'groupsUi.tab.details': 'Details',
    'groupsUi.tab.signIn': 'Sign in',
    'groupsUi.tab.signOut': 'Sign out',
    'groupsUi.tab.kiosk': 'Kiosk',
    'groupsUi.tab.data': 'Data and privacy',
    'groupsUi.field.name': 'Group name',
    'groupsUi.field.kind': 'Type',
    'groupsUi.field.language': 'Default language',
    'groupsUi.archive': 'Archive group',
    'groupsUi.restore': 'Restore group',
    'groupsUi.archive.hint': 'An archived group no longer shows on the kiosk.',
    'groupsUi.delete': 'Delete group',
    'groupsUi.delete.confirm': 'Delete this group for good',
    'groupsUi.delete.hint': 'Only possible for a group with no members and no visits.',
    'groupsUi.links.fields': 'Personal fields',
    'groupsUi.links.members': 'Members',
    'groupsUi.signIn.welcome': 'Welcome message',
    'groupsUi.signIn.welcomeHint': 'Shown on the thank-you screen after signing in. Leave empty for the standard wording.',
    'groupsUi.signOut.message': 'Sign-out message',
    'groupsUi.signOut.messageHint': 'Shown after signing out. Leave empty for the standard wording.',
    'groupsUi.kiosk.show': 'Show this group on the kiosk',
    'groupsUi.kiosk.newMembers': 'Let new people add themselves at the kiosk',
    'groupsUi.kiosk.updatePhoto': 'Let members retake their photo at the kiosk',
    'groupsUi.kiosk.nameDisplay': 'How names are shown on the kiosk',
    'groupsUi.kiosk.nameFull': 'Full name',
    'groupsUi.kiosk.nameInitial': 'First name and initial',
    'groupsUi.kiosk.pin': 'Kiosk PIN',
    'groupsUi.kiosk.pinHint': 'A 4-digit PIN needed to open this group on the kiosk.',
    'groupsUi.kiosk.pinSet': 'A PIN is set.',
    'groupsUi.kiosk.pinNone': 'No PIN is set.',
    'groupsUi.kiosk.pinNew': 'New 4-digit PIN',
    'groupsUi.kiosk.pinSave': 'Set PIN',
    'groupsUi.kiosk.pinRemove': 'Remove PIN',
    'groupsUi.data.title': 'Other settings for this group',
};
//# sourceMappingURL=w1.js.map